import { config } from "../config.js";
import { step } from "./world.js";

// リプレイとR.W.N.D.(SENSEOFVOID の replay.js と同じ考え方を、1人用に小さくしたもの)。
// 試合の映像は録らない。「同じ種・同じ入力なら同じ展開」なので、
//   - frames[tick]: そのステップに入れた入力({ mx, my, choice? }。とても小さい)
//   - keyframes: 一定間隔(config.rewind.keyframeSeconds)ごとの world の控え(JSON文字列)
// だけを持ち、好きな位置は「その手前の控えへ戻して、入力を流し込んで再計算」で作る。
// R.W.N.D.: 選んだ位置の world で試合を続け、その位置より後の記録を捨てる(fork)。

export function createRecorder(world) {
  const keyframeTicks = Math.round(config.rewind.keyframeSeconds * config.sim.tickRate);
  const frames = [];
  const keyframes = new Map();
  keyframes.set(world.tick, snapshot(world));

  // 入力を記録しながら1ステップ進める。進んだら true
  function advance(w, input) {
    const t = w.tick;
    const frame = { mx: input.mx | 0, my: input.my | 0 };
    if (input.choice != null) frame.choice = input.choice;
    if (input.rewind) frame.rewind = { heal: !!input.rewind.heal, power: !!input.rewind.power };
    if (!step(w, frame)) return false;
    frames[t] = frame;
    if (w.tick % keyframeTicks === 0) keyframes.set(w.tick, snapshot(w));
    return true;
  }

  // 記録した範囲の、指定のステップの world を作る(新しい world を返す。元の world は変えない)
  function worldAt(tick) {
    const target = Math.max(0, Math.min(tick, frames.length));
    let base = -1;
    for (const k of keyframes.keys()) if (k <= target && k > base) base = k;
    const w = JSON.parse(keyframes.get(base));
    while (w.tick < target) {
      if (!step(w, frames[w.tick])) break;
    }
    return w;
  }

  // R.W.N.D.: tick より後の記録を捨てる
  function forkAt(tick) {
    frames.length = tick;
    for (const k of [...keyframes.keys()]) if (k > tick) keyframes.delete(k);
  }

  function exportRecord() {
    return { version: config.sim.version, params: JSON.parse(keyframes.get(0)).params, frames };
  }

  // リプレイの再生: 記録した入力で1ステップ進める
  function replayStep(w) {
    if (w.tick >= frames.length) return false;
    return step(w, frames[w.tick]);
  }

  return {
    advance,
    worldAt,
    replayStep,
    forkAt,
    exportRecord,
    get endTick() {
      return frames.length;
    },
  };
}

function snapshot(world) {
  return JSON.stringify({ ...world, events: [] });
}
